import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next";

const PaymentProviderConfigAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label , load = true, infoText, error, helperText, disabled = false }) => {
    const { t } = useTranslation();


    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.paymentProviderSetting")}
            url="/autocompleteApi/PaymentProviderConfig"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={ disabled}
        />
    );
};

export default PaymentProviderConfigAutoComplete;
